import { PRODUCTS_REQUEST, PRODUCTS_SUCCESS, PRODUCTS_FAILURE } from './types';

const initialState = {
  list: [],
  loading: false,
  error: false,
  current: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case PRODUCTS_REQUEST:
      return { ...state, loading: true, error: false, current: false };
    case PRODUCTS_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case PRODUCTS_SUCCESS:
      return { ...state, list: action.payload, loading: false, error: false };
    default:
      return state;
  }
}
